module.exports = __webpack_public_path__ + "img/wange.542de3fc.jpg";